export const URLS = {
  IAM_JOBS_MANAGEMENT: '/iam/jobManagement',
  IAM_JOBS_MANAGEMENT_DETAILS: '/iam/jobManagement/job/:id',
  IAM_JOBS_CATEGORIES_LIST: '/iam/jobCategories',
  IAM_JOBS_CAT_MANAGEMENT_DETAILS: '/iam/jobManagement/jobCategory/:id',
  IAM_PARTNERS_MANAGEMENT: '/iam/externalPartners',
  IAM_PARTNER_DETAILS: '/iam/externalPartners/partner/:id',
  IAM_MANAGERS: '/iam/externalPartners/managers',
  IAM_MANAGER_DETAILS: '/iam/externalPartners/managers/:id',
  IAM_ASSIGNMENTS: '/iam/externalPartners/assignments',
  IAM_ASSIGNMENT_DETAILS: '/iam/externalPartners/assignments/:id',
  IAM_DELEGATES: '/iam/externalPartners/delegates',
  IAM_DELEGATE_DETAILS: '/iam/externalPartners/delegates/:id',
  IAM_LEGAL_ENTITIES: '/iam/externalPartners/legalEntities',
  IAM_LEGAL_ENTITY_DETAILS: '/iam/externalPartners/legalEntities/:id',
  IAM_STORES: '/iam/externalPartners/stores',
  IAM_STORE_DETAILS: '/iam/externalPartners/stores/:id'
}
